export { default } from './GeoTargetIsAccessPopUp';



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/CheckGeotargetAccess/GeoTargetIsAccessPopUp/index.js